import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { apiKey } from "../../config/config";
import { toast } from "react-toastify";
import axios from "axios";

function SubscriptionForm({ data, closeModal, customerData, paymentMethods }) {
  const customer = JSON.parse(localStorage.getItem("rms-customer"));
  const [paymentMethodId, setPaymentMethodId] = useState(1);
  const subscribe = () => {
    axios
      .post(
        `${apiKey}/api/rms/customer/subscriptions/subscribe`,
        {
          payment_method_id: paymentMethodId,
          subscription_id: data.id,
        },
        {
          headers: {
            Authorization: `Bearer ${customer?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        closeModal();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Error", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    // Add the 'body-no-scroll' class to the body when the modal is open
    document.body.classList.add("overflow-y-hidden");

    // Remove the 'overflow-y-hidden' class when the modal is closed
    return () => {
      document.body.classList.remove("overflow-y-hidden");
    };
  }, []);
  return (
    <div
      className="bg-black bg-opacity-20 w-full h-screen overflow-y-auto fixed top-0 left-0 bottom-0 z-[999] grid place-items-center p-4 fade-in"
      onClick={() => closeModal()}
    >
      <div
        className="bg-white max-w-3xl p-12 rounded-2xl relative fade-in-down"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={() => closeModal()} className="absolute top-6 right-6">
          <RxCross2 className="text-[#774d96] text-lg" />
        </button>
        <div className="max-w-md w-full">
          <h1 className="text-[2rem] font-medium">{data.subscription}</h1>
          <p className="text-lg font-light mt-2">{data.heading}</p>
          <form
            action=""
            className="mt-4 space-y-4"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="space-y-5">
              <input
                type="text"
                placeholder="Name"
                className="px-4 py-2 border rounded font-light w-full"
                defaultValue={customerData?.name || ""}
                disabled
              />
              <input
                type="text"
                placeholder="Phone"
                className="px-4 py-2 border rounded font-light w-full"
                defaultValue={customerData?.phone || ""}
                disabled
              />
              <input
                type="text"
                placeholder="Email"
                className="px-4 py-2 border rounded font-light w-full"
                defaultValue={customerData?.email || ""}
                disabled
              />
            </div>
            <div className="w-full space-y-4">
              <span className="flex gap-4 text-xs">
                <h5 className="text-w-bg">Amount: </h5>
                <p>{data.amount}</p>
              </span>
              <span className="flex gap-4 text-xs">
                <h5 className="text-w-bg">Expire Days: </h5>
                <p>{data.expire_days}</p>
              </span>
              <span className="flex gap-4 text-xs">
                <h5 className="text-w-bg">Package Details: </h5>
                <p>{data.details}</p>
              </span>
            </div>
            <hr />
            <div className="w-full text-start">
              <h4 className="text-lg font-medium">Select Payment Method</h4>
              <div className="flex gap-x-4 flex-wrap">
                {paymentMethods.map((method, idx) => (
                  <span className="flex items-center gap-2" key={idx}>
                    <input
                      type="radio"
                      name="payment"
                      id={`payment-${idx}`}
                      checked={paymentMethodId === method.id}
                      onChange={() => setPaymentMethodId(method.id)}
                    />
                    <label htmlFor={`payment-${idx}`} className="text-xs">
                      {method.name}
                    </label>
                  </span>
                ))}
              </div>
            </div>
            <button
              onClick={subscribe}
              className="bg-w-bg text-white max-w-[8rem] w-full px-2 py-1 rounded mx-auto"
            >
              Pay Now
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

function SubscriptionCard({ data, customerData, paymentMethods }) {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);
  return (
    <div className="rounded overflow-hidden border border-w-border font-medium text-center max-w-[30rem] w-full">
      <div className="bg-w-bg py-4 px-2">
        <h4 className="text-white text-xl">{data.heading}</h4>
      </div>
      <div className="text-center py-4 px-2 grid gap-2">
        <p className="text-2xl">Price - {data.amount} SAR</p>
        <p className="text-lg">
          Delivery Charges - {data.delivery_charges} SAR
        </p>
        <p className="text-lg">Discount - {data.cat_discount || 0}%</p>
        <p className="text-lg">Total Meal Quantity - {data.item_qty}</p>
        <p className="text-lg text-w-bg">On Below Categories</p>
        {data.subscription_categories.map((cat, index) => (
          <p key={index} className="text-lg font-bold">
            {cat.categories.category_name} - {cat.quantity} Meals
          </p>
        ))}
        <p className="text-lg">{data.details}</p>
        <button
          onClick={toggleModal}
          className="bg-w-bg text-white max-w-[18rem] w-full px-2 py-1 rounded mx-auto mt-4"
        >
          Subscribe Now
        </button>
      </div>
      {showModal && (
        <SubscriptionForm
          data={data}
          closeModal={toggleModal}
          customerData={customerData}
          paymentMethods={paymentMethods}
        />
      )}
    </div>
  );
}

export default SubscriptionCard;
